<template>
    <div>
        <category-picker
            :label="label"
            v-model="internalValue"
            @input="relay"
            :disabled="disabled"
            :show-category-path="false"
        ></category-picker>
    </div>
</template>

<script>
    import CategoryPicker from './forms/controls/KeenExpenseCategoryPicker'
    import { ExpenseCategoryResource } from '../classes/Api/Expense'

    export default {
        components: {
            CategoryPicker
        },
        props: {
            label: {
                type: String
            },
            value: {
                default: null
            },
            config: {
                type: Object,
                default() {
                    return {
                        type: false
                    };
                }
            },
            disabled: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                internalValue: {},
            }
        },
        created() {
            if (_.isEmpty(this.internalValue) && this.value && this.value !== '%') {
                this.setInternalValue(this.value);
            }
        },
        watch: {
            value(n,o) {
                let internalNotObject = !_.isObject(this.internalValue);
                let internalNotCurrent = _.isObject(this.internalValue) && this.internalValue.id !== n

                if (n !== o && (internalNotObject || internalNotCurrent)) {
                    this.setInternalValue(n);
                }
            }
        },
        computed: {
            type() {
                return this.config.type ? this.config.type : null;
            },
        },
        methods: {
            relay(e) {
                this.$emit('input', this.internalValue.id)
            },
            setInternalValue(id) {
                if (parseInt(id) > 0) {
                    ExpenseCategoryResource.find(id).then(response => {
                        this.internalValue = response.data;
                    }, e => handleApiError(e));
                } else {
                    this.internalValue = {};
                    this.$emit('input', '%')
                }
            }
        }
    }
</script>